import script from "./formDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./formDialog.vue?vue&type=script&setup=true&lang=js"

import "./formDialog.vue?vue&type=style&index=0&id=fcdfc9c4&lang=scss"

const __exports__ = script;

export default __exports__